import { SiteNav } from '@vwfs-bronson/bronson-react';
import React from 'react';

export type LanguageDescription = {
    /**
     * The locale code of the language (e.g. "es")
     */
    locale: string;
    /**
     * The text to show in the list of selectable options (e.g. "Spanish (ES)")
     */
    dropdownLabel: string;
    /**
     * The text to show when this language is selected by the user (e.g. "ES")
     */
    activeLabel: string;
};

export type LanguageDescriptionList = Array<LanguageDescription>;

export type LanguageSwitcherProps = {
    /**
     * The list of selectable languages
     */
    selectableLanguages: LanguageDescriptionList;
    /**
     * The currently selected language
     */
    currentLanguage: LanguageDescription;
    /**
     * Callback on each language selection
     * @param newLocale New locale
     * @param currentLocale Current locale
     */
    onClick?: (newLocale: string, currentLocale: string) => void;
    /** Optional flag to show items on top when the {@link SiteNav} is collapsed. Default true */
    topAtBreakpoint?: boolean;
};

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({
    currentLanguage,
    selectableLanguages,
    onClick,
    topAtBreakpoint = true,
}) => (
    <SiteNav.Item label={currentLanguage.activeLabel} icon reversed language topAtBreakpoint={topAtBreakpoint}>
        {selectableLanguages.map(language => (
            <SiteNav.Item.DropdownItem
                key={language.locale}
                href={language.locale ? language.locale : '#'}
                onClick={
                    onClick
                        ? event => {
                              event.preventDefault();
                              onClick(language.locale, currentLanguage.locale);
                          }
                        : undefined
                }
            >
                {language.dropdownLabel}
            </SiteNav.Item.DropdownItem>
        ))}
    </SiteNav.Item>
);
